import React from "react";

export const monthOptions = [
    { label: "Januari", value: 1 },
    { label: "Februari", value: 2 },
    { label: "Maret", value: 3 },
    { label: "April", value: 4 },
    { label: "Mei", value: 5 },
    { label: "Juni", value: 6 },
    { label: "Juli", value: 7 },
    { label: "Agustus", value: 8 },
    { label: "September", value: 9 },
    { label: "Oktober", value: 10 },
    { label: "November", value: 11 },
    { label: "Desember", value: 12 },
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});

export const configNo = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const { page, rowsPerPage } = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                return <>{rowNumber}</>;
            },
        },
    },
];

export const configNumber = [
    {
        name: "no",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                // Jika kolom 'no' tidak ada (misalnya untuk row total), tampilkan string kosong
                if (value === undefined || value === null || value === "") {
                    return "";
                }

                // Kalau ada, tetap hitung berdasarkan index
                const { page, rowsPerPage } = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;
                return <>{rowNumber}</>;
            },
        },
    },
];